module.exports = __webpack_public_path__ + "img/pg5-right3.ea97aef5.png";